<template>
  <div class="home">
   <!-- <First/> -->
   <Hero/>
   <Technology/>
   <Heading/>
   <Card/>
   <!-- <LeftHeading/>
   <Card/> -->
  </div>
</template>

<script>
// @ is an alias to /src
import First from '@/components/First.vue'
import Heading from '@/components/Heading.vue'
import Card from '@/components/Card.vue'
import Technology from '@/components/Technology.vue'
import Hero from '@/components/Hero.vue'
import LeftHeading from '@/components/HeadingLeft.vue'
import db from '../components/firebaseInit'

export default {
  name: 'home',
  data() {
    return {
      portfolios : []
    }
  },
  components: {
    First,
    Heading,
    Hero,
    Card,
    LeftHeading,
    Technology
  },
  created () {
      db.collection('portfolios').get().then((querySnapshot) => {
        this.loading = false
        querySnapshot.forEach((doc) => {
          const data = {
            'id': doc.id,
            'name': doc.data().name,
            'image': doc.data().image,
          }
          this.portfolios.push(data)
        })
      })
    },
}
</script>

<style scoped>


</style>
